/* DARKGROUND DESIGN SYSTEM · sound dock (sections/dg-previews.liquid, setting "Keep playing while scrolling")
   Marco, 2 nov 2026: "que se puedan ir escuchando sonidos durante toda la página".
   - Once a sound is played (the demo button in the hero or any sound in "Hear it before you buy"), a small player
     docks at the bottom of the screen while the player that started it is out of view: cover, sound name,
     previous / play-pause / next and a progress line. Tapping the name scrolls back to the sound list.
     The close button pauses and hides it until the next play.
   - When a sound ends on its own, the next one in the list starts (unless the visitor paused or touched a player),
     so the pack plays through while they read the page (it stops after the last sound).
   - It drives the existing players (assets/dg-commerce.js) by clicking their own buttons, so there is still only one
     sound at a time and the hero, the list and the dock always agree.
   - Sits above the sticky buy bar when that bar is showing (--dg-sticky-h, set in sections/dg-ui-fixes.liquid).
*/
(function () {
  'use strict';
  if (window.__dgDock) return;
  window.__dgDock = true;

  var ICON_PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor"></path></svg>';
  var ICON_PAUSE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5h4v14H7zM13 5h4v14h-4z" fill="currentColor"></path></svg>';
  var ICON_PREV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 5h2v14H6zM20 5v14L9 12z" fill="currentColor"></path></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M16 5h2v14h-2zM4 5v14l11-7z" fill="currentColor"></path></svg>';
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7l10 10M17 7 7 17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path></svg>';
  var USER_SEL = '[data-dg-demo-play], .dg-tile, .dg-ftrack__play, .dg-ftrack__wave, .dg-dock button';

  /* Knowing that a sound really ended (and was not paused or replaced) needs the "ended" event of the preview audio,
     which dg-commerce.js keeps off the page. The first time any off-page sound plays, listen for its end. */
  var endedAt = 0;
  var nativePlay = window.HTMLMediaElement && HTMLMediaElement.prototype.play;
  if (nativePlay) {
    HTMLMediaElement.prototype.play = function () {
      if (!this.isConnected && !this.__dgDockEnd) {
        this.__dgDockEnd = true;
        this.addEventListener('ended', function () { endedAt = Date.now(); });
      }
      return nativePlay.apply(this, arguments);
    };
  }
  function justEnded() { return Date.now() - endedAt < 2000; }

  function init(root) {
    if (root.dataset.dgDock) return true;
    var box = root.querySelector('.dg-ftrack');
    var tilesEl = root.querySelector('[data-dg-tiles]');
    if (!box || !tilesEl || !tilesEl.querySelector('.dg-tile')) return false;
    root.dataset.dgDock = '1';

    var section = root.closest('.dg-previews-wrap') || root;
    var cover = root.getAttribute('data-cover') || '';
    var autoNext = root.getAttribute('data-auto-next') !== 'false';
    var fPlay = box.querySelector('.dg-ftrack__play');
    var fTitle = box.querySelector('.dg-ftrack__title');
    var hero = document.querySelector('[data-dg-demo]');
    var hBtn = hero ? hero.querySelector('[data-dg-demo-play]') : null;
    var hBar = hero ? hero.querySelector('[data-dg-demo-bar]') : null;

    var dock = document.createElement('div');
    dock.className = 'dg dg-dock';
    dock.setAttribute('role', 'region');
    dock.setAttribute('aria-label', 'Sound player');
    dock.setAttribute('aria-hidden', 'true');
    dock.inert = true;
    dock.innerHTML = '<span class="dg-dock__bar" aria-hidden="true"><i></i></span>'
      + (cover ? '<span class="dg-dock__art"><img alt="" loading="lazy"></span>' : '')
      + '<button type="button" class="dg-dock__meta" data-a="list" aria-label="Show all sounds"><span class="dg-dock__label"></span><span class="dg-dock__title"></span></button>'
      + '<span class="dg-dock__ctrls">'
      + '<button type="button" class="dg-dock__btn dg-dock__btn--side" data-a="prev" aria-label="Previous sound">' + ICON_PREV + '</button>'
      + '<button type="button" class="dg-dock__btn dg-dock__btn--main" data-a="toggle" aria-label="Play">' + ICON_PLAY + '</button>'
      + '<button type="button" class="dg-dock__btn dg-dock__btn--side" data-a="next" aria-label="Next sound">' + ICON_NEXT + '</button>'
      + '</span>'
      + '<button type="button" class="dg-dock__close" data-a="close" aria-label="Close the player">' + ICON_CLOSE + '</button>';
    if (cover) dock.querySelector('.dg-dock__art img').src = cover;
    document.body.appendChild(dock);

    var bar = dock.querySelector('.dg-dock__bar i');
    var titleEl = dock.querySelector('.dg-dock__title');
    var mainBtn = dock.querySelector('[data-a="toggle"]');
    dock.querySelector('.dg-dock__label').textContent = root.getAttribute('data-dock-label') || 'Now playing';

    var src = 'list';
    var started = false, closed = false, userPaused = false, lastAct = 0, raf = 0;
    var listOn = false, heroOn = false, listInView = true, heroInView = false;
    var listPct = 0, heroPct = 0;

    function tiles() { return Array.prototype.slice.call(tilesEl.querySelectorAll('.dg-tile')); }
    function current() {
      if (src === 'hero') return 0;
      var t = tiles();
      for (var i = 0; i < t.length; i++) { if (t[i].classList.contains('is-current')) return i; }
      return 0;
    }
    function go(step) {
      var t = tiles();
      if (!t.length) return;
      t[(current() + step + t.length) % t.length].click();
    }
    function listHead() {
      var h = box.querySelector('.dg-ftrack__head');
      return h ? (parseFloat(h.style.left) || 0) / 100 : 0;
    }
    function heroHead() { return hBar ? (parseFloat(hBar.style.width) || 0) / 100 : 0; }
    function playing() { return src === 'hero' ? heroOn : listOn; }
    function loop() {
      raf = 0;
      if (!listOn && !heroOn) return;
      if (listOn) listPct = listHead();
      if (heroOn) heroPct = heroHead();
      bar.style.width = ((src === 'hero' ? heroPct : listPct) * 100) + '%';
      raf = requestAnimationFrame(loop);
    }
    function title() {
      if (src === 'hero') {
        var first = tilesEl.querySelector('.dg-tile .dg-tile__name');
        return (first && first.textContent) || 'Demo';
      }
      return (fTitle && fTitle.textContent) || '';
    }
    function render() {
      var on = playing();
      titleEl.textContent = title();
      mainBtn.innerHTML = on ? ICON_PAUSE : ICON_PLAY;
      mainBtn.setAttribute('aria-label', on ? 'Pause' : 'Play');
      dock.classList.toggle('is-playing', on);
      if ((listOn || heroOn) && !raf) raf = requestAnimationFrame(loop);
      var own = src === 'hero' ? (heroInView || listInView) : listInView;
      var show = started && !closed && !own;
      dock.classList.toggle('is-on', show);
      dock.setAttribute('aria-hidden', show ? 'false' : 'true');
      dock.inert = !show;
      document.documentElement.classList.toggle('dg-dock-on', show);
    }
    /* a sound that stopped by itself (not paused, not replaced by a click) moves on to the next one */
    function stopped(which) {
      var paused = userPaused;
      setTimeout(function () {
        if (!autoNext || paused || closed || src !== which) return;
        if (listOn || heroOn) return;
        if (Date.now() - lastAct < 400) return;
        if (justEnded() && current() < tiles().length - 1) go(1);
      }, 120);
    }

    function onList() {
      var on = box.classList.contains('is-active');
      if (on && !listOn) { src = 'list'; started = true; closed = false; userPaused = false; }
      if (listOn && !on) stopped('list');
      listOn = on;
      render();
    }
    function onHero() {
      var on = !!hBtn && hBtn.getAttribute('aria-label') === 'Pause demo';
      if (on && !heroOn) { src = 'hero'; started = true; closed = false; userPaused = false; }
      if (heroOn && !on) stopped('hero');
      heroOn = on;
      render();
    }

    new MutationObserver(onList).observe(box, { attributes: true, attributeFilter: ['class'] });
    if (fTitle) new MutationObserver(render).observe(fTitle, { childList: true, characterData: true, subtree: true });
    if (hBtn) new MutationObserver(onHero).observe(hBtn, { attributes: true, attributeFilter: ['aria-label'] });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { listInView = en.isIntersecting; });
        render();
      }, { threshold: 0.12 }).observe(section);
      if (hero) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { heroInView = en.isIntersecting; });
          render();
        }, { threshold: 0.5 }).observe(hero);
      }
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest(USER_SEL)) lastAct = Date.now();
    }, true);

    dock.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-a]') : null;
      if (!b) return;
      var a = b.getAttribute('data-a');
      if (a === 'toggle') {
        if (playing()) userPaused = true;
        if (src === 'hero' && hBtn) hBtn.click(); else if (fPlay) fPlay.click();
      } else if (a === 'next') {
        go(1);
      } else if (a === 'prev') {
        go(-1);
      } else if (a === 'list') {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (a === 'close') {
        if (playing()) { userPaused = true; if (src === 'hero' && hBtn) hBtn.click(); else if (fPlay) fPlay.click(); }
        closed = true;
        render();
      }
    });
    onList();
    onHero();
    return true;
  }

  function setup() {
    var roots = document.querySelectorAll('[data-dg-previews][data-dock]');
    if (!roots.length) return;
    var tries = 0;
    (function wait() {
      var pending = 0;
      roots.forEach(function (r) { if (!init(r)) pending++; });
      if (pending && ++tries < 60) setTimeout(wait, 500);
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
